<template>
    <form id="reservation-form">
        <div v-if="Object.keys(this.timetables).length === 0" class="loading">
            <i class="fas fa-spinner fa-spin"></i> Načítání
        </div>
        <template v-if="Object.keys(this.timetables).length !== 0">
            <table class="reservation-weeks form-group">
                <thead>
                    <tr>
                        <th v-for="(timetable, index) in this.timetables">
                            <div class="btn" :class="{'btn-light': selectedWeek != index, 'btn-primary': selectedWeek == index}" v-on:click="selectWeek(index)">
                                {{ timetable.week_start }} - {{ timetable.week_end }}<br>
                                <span class="badge badge-pill" :class="[getCountClass(index, timetable.counts)]">{{ timetable.counts }}</span>
                            </div>
                        </th>
                    </tr>
                </thead>
            </table>
            <table class="reservation-timetable form-group">
                <thead>
                    <tr>
                        <th>
                            Čas
                        </th>
                        <th>
                            Po
                        </th>
                        <th>
                            Út
                        </th>
                        <th>
                            St
                        </th>
                        <th>
                            Čt
                        </th>
                        <th>
                            Pá
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="time" :class="['hours-range-' + this.hoursRange]">
                            <div class="time-label" v-for="i in (this.hoursRange + 1)">
                                {{ i + hoursStart - 1 }}:00
                            </div>
                        </td>
                        <td class="day">
                            <div class="hour-line" v-for="i in (this.hoursRange + 1)"></div>
                            <template v-for="(timetable, index) in this.timetables">
                                <div v-for="term in timetable.terms.mo" v-show="selectedWeek == index" class="tutoring-hour" :class="[{'occupied': term.occupied, 'locked': !term.occupied && term.locked, 'selected': term.selected}, 'tutoring-hour-length-' + term.length, 'tutoring-hour-position-' + (term.start_hours - hoursStart) + '-' + term.start_minutes]" v-on:click="selectUnselectTerm(term)">
                                    {{ term.occupied ? 'Obsazeno' : (term.locked ? 'Zablokováno' : (term.selected ? 'Vybráno' : 'Volno')) }}
                                </div>
                            </template>
                        </td>
                        <td class="day">
                            <div class="hour-line" v-for="i in (this.hoursRange + 1)"></div>
                            <template v-for="(timetable, index) in this.timetables">
                                <div v-for="term in timetable.terms.tu" v-show="selectedWeek == index" class="tutoring-hour" :class="[{'occupied': term.occupied, 'locked': !term.occupied && term.locked, 'selected': term.selected}, 'tutoring-hour-length-' + term.length, 'tutoring-hour-position-' + (term.start_hours - hoursStart) + '-' + term.start_minutes]" v-on:click="selectUnselectTerm(term)">
                                    {{ term.occupied ? 'Obsazeno' : (term.locked ? 'Zablokováno' : (term.selected ? 'Vybráno' : 'Volno')) }}
                                </div>
                            </template>
                        </td>
                        <td class="day">
                            <div class="hour-line" v-for="i in (this.hoursRange + 1)"></div>
                            <template v-for="(timetable, index) in this.timetables">
                                <div v-for="term in timetable.terms.we" v-show="selectedWeek == index" class="tutoring-hour" :class="[{'occupied': term.occupied, 'locked': !term.occupied && term.locked, 'selected': term.selected}, 'tutoring-hour-length-' + term.length, 'tutoring-hour-position-' + (term.start_hours - hoursStart) + '-' + term.start_minutes]" v-on:click="selectUnselectTerm(term)">
                                    {{ term.occupied ? 'Obsazeno' : (term.locked ? 'Zablokováno' : (term.selected ? 'Vybráno' : 'Volno')) }}
                                </div>
                            </template>
                        </td>
                        <td class="day">
                            <div class="hour-line" v-for="i in (this.hoursRange + 1)"></div>
                            <template v-for="(timetable, index) in this.timetables">
                                <div v-for="term in timetable.terms.th" v-show="selectedWeek == index" class="tutoring-hour" :class="[{'occupied': term.occupied, 'locked': !term.occupied && term.locked, 'selected': term.selected}, 'tutoring-hour-length-' + term.length, 'tutoring-hour-position-' + (term.start_hours - hoursStart) + '-' + term.start_minutes]" v-on:click="selectUnselectTerm(term)">
                                    {{ term.occupied ? 'Obsazeno' : (term.locked ? 'Zablokováno' : (term.selected ? 'Vybráno' : 'Volno')) }}
                                </div>
                            </template>
                        </td>
                        <td class="day">
                            <div class="hour-line" v-for="i in (this.hoursRange + 1)"></div>
                            <template v-for="(timetable, index) in this.timetables">
                                <div v-for="term in timetable.terms.fr" v-show="selectedWeek == index" class="tutoring-hour" :class="[{'occupied': term.occupied, 'locked': !term.occupied && term.locked, 'selected': term.selected}, 'tutoring-hour-length-' + term.length, 'tutoring-hour-position-' + (term.start_hours - hoursStart) + '-' + term.start_minutes]" v-on:click="selectUnselectTerm(term)">
                                    {{ term.occupied ? 'Obsazeno' : (term.locked ? 'Zablokováno' : (term.selected ? 'Vybráno' : 'Volno')) }}
                                </div>
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="form-fields">
                <div class="row form-group">
                    <div class="col-md-3 col-form-label">
                        Vybrané hodiny<span class="text-danger">*</span>
                    </div>
                    <div class="col-md-9">
                        <div class="form-control" readonly v-if="this.totalCount == 0">
                            -- Není nic vybráno --
                        </div>
                        <template v-for="timetable in this.timetables">
                            <div class="input-group selected-tutoring" v-for="term in timetable.terms.mo" v-if="term.selected">
                                <input type="hidden" name="terms[]" :value="term.id">
                                <div class="form-control" readonly>
                                    {{ term.date_string }} {{ term.start_time_string }} ({{ term.length }} min)
                                </div>
                                <div class="input-group-append">
                                    <button class="btn btn-danger" type="button" v-on:click="selectUnselectTerm(term)">&times;</button>
                                </div>
                            </div>
                            <div class="input-group selected-tutoring" v-for="term in timetable.terms.tu" v-if="term.selected">
                                <input type="hidden" name="terms[]" :value="term.id">
                                <div class="form-control" readonly>
                                    {{ term.date_string }} {{ term.start_time_string }} ({{ term.length }} min)
                                </div>
                                <div class="input-group-append">
                                    <button class="btn btn-danger" type="button" v-on:click="selectUnselectTerm(term)">&times;</button>
                                </div>
                            </div>
                            <div class="input-group selected-tutoring" v-for="term in timetable.terms.we" v-if="term.selected">
                                <input type="hidden" name="terms[]" :value="term.id">
                                <div class="form-control" readonly>
                                    {{ term.date_string }} {{ term.start_time_string }} ({{ term.length }} min)
                                </div>
                                <div class="input-group-append">
                                    <button class="btn btn-danger" type="button" v-on:click="selectUnselectTerm(term)">&times;</button>
                                </div>
                            </div>
                            <div class="input-group selected-tutoring" v-for="term in timetable.terms.th" v-if="term.selected">
                                <input type="hidden" name="terms[]" :value="term.id">
                                <div class="form-control" readonly>
                                    {{ term.date_string }} {{ term.start_time_string }} ({{ term.length }} min)
                                </div>
                                <div class="input-group-append">
                                    <button class="btn btn-danger" type="button" v-on:click="selectUnselectTerm(term)">&times;</button>
                                </div>
                            </div>
                            <div class="input-group selected-tutoring" v-for="term in timetable.terms.fr" v-if="term.selected">
                                <input type="hidden" name="terms[]" :value="term.id">
                                <div class="form-control" readonly>
                                    {{ term.date_string }} {{ term.start_time_string }} ({{ term.length }} min)
                                </div>
                                <div class="input-group-append">
                                    <button class="btn btn-danger" type="button" v-on:click="selectUnselectTerm(term)">&times;</button>
                                </div>
                            </div>
                        </template>
                        <div class="invalid-feedback" v-if="errors['terms.*']" :class="{'d-block': errors['terms.*']}">
                            <template v-for="message in errors['terms.*']">
                                {{ message }}<br/>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-md-3 col-form-label" for="form-firstname">
                        Jméno<span class="text-danger">*</span>
                    </label>
                    <div class="col-md-9">
                        <input type="text" id="form-firstname" name="firstname" class="form-control" :class="{'is-invalid': errors.firstname}" placeholder="Jméno" required>
                        <div class="invalid-feedback" v-if="errors.firstname">
                            <template v-for="message in errors.firstname">
                                {{ message }}<br/>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-md-3 col-form-label" for="form-lastname">
                        Příjmení<span class="text-danger">*</span>
                    </label>
                    <div class="col-md-9">
                        <input type="text" id="form-lastname" name="lastname" class="form-control" :class="{'is-invalid': errors.lastname}" placeholder="Příjmení" required>
                        <div class="invalid-feedback" v-if="errors.lastname">
                            <template v-for="message in errors.lastname">
                                {{ message }}<br/>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-md-3 col-form-label" for="form-email">
                        E-mail<span class="text-danger">*</span>
                    </label>
                    <div class="col-md-9">
                        <input type="text" id="form-email" name="email" class="form-control" :class="{'is-invalid': errors.email}" placeholder="E-mail" required>
                        <div class="invalid-feedback" v-if="errors.email">
                            <template v-for="message in errors.email">
                                {{ message }}<br/>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-md-3 col-form-label" for="form-phone">
                        Telefon
                    </label>
                    <div class="col-md-9">
                        <input type="text" id="form-phone" name="phone" class="form-control" :class="{'is-invalid': errors.phone}" placeholder="Telefon (formát: +420 721 881 311)">
                        <div class="invalid-feedback" v-if="errors.phone">
                            <template v-for="message in errors.phone">
                                {{ message }}<br/>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-md-3 col-form-label" for="form-address-street">
                        Fakturační adresa<span class="text-danger">*</span>
                    </label>
                    <div class="col-md-4">
                        <input type="text" id="form-address-street" name="address_street" class="form-control" :class="{'is-invalid': errors.address_street}" placeholder="Ulice a číslo popisné" required>
                        <div class="invalid-feedback" v-if="errors.address_street">
                            <template v-for="message in errors.address_street">
                                {{ message }}<br/>
                            </template>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <input type="text" id="form-address-post-code" name="address_post_code" class="form-control" :class="{'is-invalid': errors.address_post_code}" placeholder="PSČ" required>
                        <div class="invalid-feedback" v-if="errors.address_post_code">
                            <template v-for="message in errors.address_post_code">
                                {{ message }}<br/>
                            </template>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <input type="text" id="form-address-city" name="address_city" class="form-control" :class="{'is-invalid': errors.address_city}" placeholder="Město" required>
                        <div class="invalid-feedback" v-if="errors.address_city">
                            <template v-for="message in errors.address_city">
                                {{ message }}<br/>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-md-3 col-form-label" for="form-course">
                        Kurz<span class="text-danger">*</span>
                    </label>
                    <div class="col-md-9">
                        <select id="form-course" name="course" class="form-control" :class="{'is-invalid': errors.course}" required>
                            <option value="" disabled selected>Vyberte si kurz...</option>
                            <option v-for="item in this.courses" :value="item.key">{{ item.value }}</option>
                        </select>
                        <div class="invalid-feedback" v-if="errors.course">
                            <template v-for="message in errors.course">
                                {{ message }}<br/>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-md-3 col-form-label" for="form-school-year">
                        ZŠ/SŠ/VŠ ročník
                    </label>
                    <div class="col-md-9">
                        <input type="number" id="form-school-year" name="school_year" class="form-control" :class="{'is-invalid': errors.school_year}" placeholder="Ročník" min="1" max="9">
                        <div class="invalid-feedback" v-if="errors.school_year">
                            <template v-for="message in errors.school_year">
                                {{ message }}<br/>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-md-3 col-form-label" for="form-subject">
                        Téma doučování
                    </label>
                    <div class="col-md-9">
                        <textarea id="form-subject" name="subject" class="form-control" :class="{'is-invalid': errors.subject}" placeholder="Téma" maxlength="4096"></textarea>
                        <div class="invalid-feedback" v-if="errors.subject">
                            <template v-for="message in errors.subject">
                                {{ message }}<br/>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-md-3 col-form-label">
                        Typ doučování<span class="text-danger">*</span>
                    </label>
                    <div class="col-md-9">
                        <div class="form-check form-check-inline">
                            <input type="radio" id="form-type-office" name="type" class="form-check-input" :class="{'is-invalid': errors.type}" value="office" required checked="checked">
                            <label for="form-type-office" class="form-check-label">Prezenčně v kanceláři</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input type="radio" id="form-type-online" name="type" class="form-check-input" :class="{'is-invalid': errors.type}" value="online" required>
                            <label for="form-type-online" class="form-check-label">Online</label>
                        </div>
                        <div class="invalid-feedback" v-if="errors.type" :class="{'d-block': errors.type}">
                            <template v-for="message in errors.type">
                                {{ message }}<br/>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-md-3 col-form-label" for="form-note">
                        Poznámka
                    </label>
                    <div class="col-md-9">
                        <textarea id="form-note" name="note" class="form-control" :class="{'is-invalid': errors.note}" placeholder="Poznámka" maxlength="4096"></textarea>
                        <div class="invalid-feedback" v-if="errors.note">
                            <template v-for="message in errors.note">
                                {{ message }}<br/>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-md-3 col-form-label">
                    </label>
                    <div class="col-md-9">
                        <div class="form-check">
                            <input type="checkbox" id="form-consent-business" name="consent_business" class="form-check-input" :class="{'is-invalid': errors.consent_business}" value="1" required>
                            <label for="form-consent-business" class="form-check-label">Souhlasím s <a href="#">obchodními podmínkami</a><span class="text-danger">*</span></label>
                        </div>
                        <div class="invalid-feedback" v-if="errors.consent_business" :class="{'d-block': errors.consent_business}">
                            <template v-for="message in errors.consent_business">
                                {{ message }}<br/>
                            </template>
                        </div>
                        <div class="form-check">
                            <input type="checkbox" id="form-consent-personal" name="consent_personal" class="form-check-input" :class="{'is-invalid': errors.consent_personal}" value="1" required>
                            <label for="form-consent-personal" class="form-check-label">Souhlasím se <a href="#">zpracováním osobních údajů</a><span class="text-danger">*</span></label>
                        </div>
                        <div class="invalid-feedback" v-if="errors.consent_personal" :class="{'d-block': errors.consent_personal}">
                            <template v-for="message in errors.consent_personal">
                                {{ message }}<br/>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-md-12">
                    <button class="btn btn-primary w-100" v-on:click="sendFormData()" :disabled="this.saving">
                        <i class="fas fa-spinner fa-spin" v-if="this.saving"></i> Rezervovat
                    </button>
                </div>
            </div>
        </template>
        <!-- Modals -->
        <div class="modal fade" id="removedSelectedTermsModal" tabindex="-1" role="dialog" aria-labelledby="removedSelectedTermsModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="removedSelectedTermsModalTitle">Upozornění</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        Bohužel následující termíny již nejsou k dispozici (jsou buď obsazeny, nebo zablokovány), a tudíž byly odebrány z výběru.
                        <ul>
                            <li v-for="term in this.removedSelectedTerms">{{ term.date_string }} {{ term.start_time_string }} ({{ term.length }} min)</li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal">Rozumím</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="successReservationModal" tabindex="-1" role="dialog" aria-labelledby="successReservationModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="successReservationModalTitle">Rezervováno</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        Vybrané termíny byly rezervovány, za chvíli Vám přijde e-mail s podrobnějšími informacemi.
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Zavřít</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            hoursStart: {
                type: Number,
                default: 12
            },
            hoursEnd: {
                type: Number,
                default: 20
            },
            courses: {
                type: Array,
                validator: function (value) {
                    for (const type of value) {
                        if (!type.hasOwnProperty('key')) {
                            return false;
                        }
                        if (!type.hasOwnProperty('value')) {
                            return false;
                        }
                    }
                    return true;
                }
            },
            urlGetActualTimetables: {
                type: String,
                required: true
            },
            urlReservation: {
                type: String,
                required: true
            }
        },

        data: function () {
            return {
                timetables: {},
                termsList: {},
                removedSelectedTerms: [],
                errors: {},
                selectedWeek: null,
                updateAction: null,
                saving: false,
            }
        },

        computed: {
            hoursRange: function () {
                return this.hoursEnd - this.hoursStart;
            },

            totalCount: function () {
                let totalCount = 0;

                for (let index in this.timetables) {
                    totalCount = totalCount + this.timetables[index].counts;
                }

                return totalCount;
            }
        },

        mounted() {
            this.loadActualTimetables();

            this.updateAction = setInterval(() => {
                this.loadActualTimetables();
            }, 10000);

            $('#removedSelectedTermsModal').on('hidden.bs.modal', (e) => {
                Vue.set(this, 'removedSelectedTerms', []);
            })
        },

        beforeDestroy: function () {
            clearInterval(this.updateAction);
        },

        methods: {
            sendFormData: function () {
                Vue.set(this, 'saving', true);
                Vue.set(this, 'errors', {});

                let form = document.getElementById("reservation-form");
                let formData = new FormData(document.getElementById("reservation-form"));

                axios.post(this.urlReservation, formData)
                    .then((response) => {
                        for (const termIndex in this.termsList) {
                            let term = this.termsList[termIndex];

                            Vue.set(newTerm, 'selected', false);
                        }

                        form.reset();

                        $("#successReservationModal").modal();

                        this.loadActualTimetables();

                        Vue.set(this, 'saving', false);
                    })
                    .catch((error) => {
                        if (error.response) {
                            if (error.response.status == 422) {
                                let errors = error.response.data.errors;

                                // Specific handle of terms errors.
                                for (let errorIndex in errors) {
                                    if (errorIndex.startsWith('terms')) {
                                        if (!errors['terms.*']) {
                                            errors['terms.*'] = [];
                                        }
                                        errors['terms.*'] = errors['terms.*'].concat(errors[errorIndex]);
                                    }
                                }

                                Vue.set(this, 'errors', errors);
                            } else {
                                console.error(`Error ${error.response.status}: ${error.response.data.message}`);
                            }
                        }

                        this.loadActualTimetables()
                            .then((returnVal) => {
                                Vue.set(this, 'saving', false);
                            })
                            .catch((err) => {
                                Vue.set(this, 'saving', false);
                            });
                    });
            },

            loadActualTimetables: function () {
                return axios.get(this.urlGetActualTimetables)
                    .then((response) => {
                        try {
                            this.onLoadActualTimetables(response.data);

                            if (this.removedSelectedTerms.length != 0) {
                                $("#removedSelectedTermsModal").modal();
                            }
                        } catch (error) {
                            console.error(error);
                        }
                    })
                    .catch((error) => {
                        let message = null;
                        if (error.response.data.message) {
                            message = "Message: " + error.response.data.message;
                        }

                        console.error("Can't load actual timetable.","\n","Error code: " + error.response.status,"\n",message);
                    });
            },

            onLoadActualTimetables: function (data) {
                // Create new term list.
                let newTermList = {};

                for (const timetableIndex in data) {
                    let timetable = data[timetableIndex];

                    Vue.set(timetable, 'counts', 0);

                    for (const termIndex in timetable.terms.mo) {
                        let term = timetable.terms.mo[termIndex];

                        Vue.set(term, 'selected', false);

                        newTermList[term.id] = term;
                    }
                    for (const termIndex in timetable.terms.tu) {
                        let term = timetable.terms.tu[termIndex];

                        Vue.set(term, 'selected', false);
                        
                        newTermList[term.id] = term;
                    }
                    for (const termIndex in timetable.terms.we) {
                        let term = timetable.terms.we[termIndex];

                        Vue.set(term, 'selected', false);
                        
                        newTermList[term.id] = term;
                    }
                    for (const termIndex in timetable.terms.th) {
                        let term = timetable.terms.th[termIndex];

                        Vue.set(term, 'selected', false);
                        
                        newTermList[term.id] = term;
                    }
                    for (const termIndex in timetable.terms.fr) {
                        let term = timetable.terms.fr[termIndex];

                        Vue.set(term, 'selected', false);
                        
                        newTermList[term.id] = term;
                    }
                }

                // Get selected terms that now is not available.
                // Also set selected attribute to new data.
                let removedSelectedTerms = this.removedSelectedTerms;

                for (const termIndex in this.termsList) {
                    let term = this.termsList[termIndex];
                    let newTerm = newTermList[termIndex];

                    if (newTerm != undefined) {
                        if ((newTerm.occupied == true || newTerm.locked == true) && term.selected == true) {
                            // Term can't be selected anymore.
                            removedSelectedTerms.push(term);
                        } else {
                            Vue.set(newTerm, 'selected', term.selected);
                        }
                    } else {
                        removedSelectedTerms.push(term);
                    }
                }

                // Set new data.
                Vue.set(this, 'timetables', data);
                Vue.set(this, 'termsList', newTermList);
                Vue.set(this, 'removedSelectedTerms', removedSelectedTerms);

                // Recalculate selected terms in weeks.
                this.recalculateTimetables();

                // Select week if not selected.
                if (this.selectedWeek == null) {
                    Vue.set(this, 'selectedWeek', Object.keys(this.timetables)[0]);
                }
            },

            recalculateTimetables: function () {
                for (const timetableIndex in this.timetables) {
                    let timetable = this.timetables[timetableIndex];

                    Vue.set(timetable, 'counts', 0);

                    for (const termIndex in timetable.terms.mo) {
                        let term = timetable.terms.mo[termIndex];
                        if (term.selected == true) {
                            Vue.set(timetable, 'counts', timetable.counts + 1);
                        }
                    }
                    for (const termIndex in timetable.terms.tu) {
                        let term = timetable.terms.tu[termIndex];
                        if (term.selected == true) {
                            Vue.set(timetable, 'counts', timetable.counts + 1);
                        }
                    }
                    for (const termIndex in timetable.terms.we) {
                        let term = timetable.terms.we[termIndex];
                        if (term.selected == true) {
                            Vue.set(timetable, 'counts', timetable.counts + 1);
                        }
                    }
                    for (const termIndex in timetable.terms.th) {
                        let term = timetable.terms.th[termIndex];
                        if (term.selected == true) {
                            Vue.set(timetable, 'counts', timetable.counts + 1);
                        }
                    }
                    for (const termIndex in timetable.terms.fr) {
                        let term = timetable.terms.fr[termIndex];
                        if (term.selected == true) {
                            Vue.set(timetable, 'counts', timetable.counts + 1);
                        }
                    }
                }
            },

            selectUnselectTerm: function (term) {
                if (term.occupied || term.locked) {
                    return;
                }

                Vue.set(term, 'selected', !term.selected);

                this.recalculateTimetables();
            },

            getCountClass: function (index, count) {
                if (count > 0) {
                    return 'badge-success';
                } else if (index == this.selectedWeek) {
                    return 'badge-light';
                }
                
                return 'badge-dark';
            },

            selectWeek: function (index) {
                Vue.set(this, 'selectedWeek', index);
            }
        }
    }
</script>
